
import { pipelineContext, runPipeline } from './pipelineRunner.js'
import { claimWarningsPipeline } from './claimWarningsPipeline.js'

let runClaimWarningsPipeline = (selectedClaim) => {

    let context = pipelineContext(selectedClaim)


    return runPipeline(claimWarningsPipeline, context)
}

export { runClaimWarningsPipeline }